import styled from "styled-components";

export const ContainerIconesPageStyle = styled.div`
  .button {
    width: 18rem !important;
  }

  .code-container {
    background-color: #111;
    padding: 0.5rem;    
  }  
`;
